import { n as d, T as u } from "../../index-DDwX5WiL.js";
const a = "seconds", T = ["years", "months", "days", "hours", "minutes", "seconds"], i = 1e3, c = 60 * i, r = 60 * c, t = 24 * r, S = {
  days: t,
  hours: r,
  minutes: c,
  months: t,
  seconds: i,
  years: t
};
function N(l) {
  const n = d(l), s = u.Now.zonedDateTimeISO(n.timeZoneId).until(n, { largestUnit: "years", smallestUnit: a }), o = T.find((M) => s[M] !== 0) || a, m = s.total({ relativeTo: n, unit: "millisecond" }), e = S[o];
  return { nextIntervalMs: Math.min(e - Math.abs(m % e), t), unit: o, value: s[o] };
}
export {
  N as getRelativeTimeUpdateInfo
};
